import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { InfoList } from '@p81-common/ui';
import makeStyles from '@mui/styles/makeStyles';
import { useHistory } from 'react-router-dom';
import { useAuthState } from 'contexts/auth-context';
import { getInitialsFull, getInitials, colorList } from 'utils/common';
import { getRequest, postRequest } from 'utils/requests';
import { useRightSideBar } from '@p81-common/ui';
import { Loading } from 'components/common/Elements/Elements';
import { useContent } from 'contexts/content-context';
import { setUnreadNotificationsCount } from 'contexts/actions/contentAction';

const createClasses = makeStyles(theme => ({
  tab: {
    color: `${theme.palette.secondary[500]} !important`
  }
}));

const Notifications = () => {
  const [notifList, setNotifList] = useState([]);
  const [filter, setFilter] = useState('All');

  const { contentDispatch, contentState } = useContent();

  const { setOpenSecondary } = useRightSideBar();

  const unmount = useRef(false);

  const classes = createClasses();

  const history = useHistory();
  const { user } = useAuthState().auth;

  useEffect(() => {
    return () => {
      unmount.current = true;
    };
  }, []);

  const createData = data => {
    setNotifList(parserDataNotif(data));
  };

  const parserDataNotif = listNotifList => {
    const newListNotif = listNotifList.map(notif => {
      return {
        id: notif._id,
        title: notif.title,
        text: notif.message,
        description: moment(notif._created_at).fromNow(),
        isActive: !notif.isRead,
        avatarProps: {
          initials: getInitialsFull(notif.recivedFrom),
          backgroundColor:
            getInitials(user.firstName, user.lastName) ===
            getInitialsFull(notif.recivedFrom)
              ? user.initialsColor
              : notif.initialsColor &&
                notif.initialsColor !== '-' &&
                notif.initialsColor !== 'NA'
              ? notif.initialsColor
              : colorList[
                  (getInitialsFull(notif.recivedFrom).charCodeAt(0) +
                  getInitialsFull(notif.recivedFrom).charCodeAt(1)
                    ? getInitialsFull(notif.recivedFrom).charCodeAt(1)
                    : 0) %
                    (colorList.length - 1)
                ]
        },
        statusTooltipProps: {
          title: notif.isRead ? 'HIDE' : 'Mark as read',
          placement: 'left'
        }
      };
    });
    contentDispatch(
      setUnreadNotificationsCount(
        newListNotif.filter(notif => notif.isActive === true).length
      )
    );
    return newListNotif;
  };

  const updateNotif = () => {
    getRequest('/user/notifications/new').catch(err => {
      !unmount.current && console.log(err);
    });
    getRequest('/user/notifications/list')
      .then(res => {
        !unmount.current && createData(res.body);
      })
      .catch(err => {
        !unmount.current && console.log(err);
      });
  };

  useEffect(() => {
    updateNotif();
    // eslint-disable-next-line
  }, []);

  const handleListItemClick = id => () => {
    postRequest('/user/notification/markasread', {
      notifId: id
    })
      .then(() => {
        setNotifList(
          notifList.map(notif =>
            notif.id !== id ? notif : { ...notif, isActive: false }
          )
        );
        contentDispatch(
          setUnreadNotificationsCount(contentState.unreadNotificationsCount - 1)
        );
      })
      .catch(err => {
        console.log(err);
      });
  };

  const readAll = () => {
    getRequest('/user/notifications/markallasread')
      .then(() => {
        !unmount.current && updateNotif();
      })
      .catch(err => {
        !unmount.current && console.log(err);
      });
  };

  const filterList = notifList => {
    return filter === 'All'
      ? notifList
      : notifList.filter(notif => notif.isActive === true);
  };

  const infoDrawerId = 'infoDrawer';

  const infoListProps = {
    hideClose: true,
    handleListItemClick: handleListItemClick,
    handleStatusDotClick: () => {},
    tabsButtons: [
      {
        children: 'Mark All as Read',
        onClick: readAll
      },
      {
        children: 'Show all',
        onClick: () => {
          history.push('/notifications');
          setOpenSecondary(false);
        }
      }
    ],
    listItems: filterList(notifList),
    title: 'Notifications',
    tabsProps: {
      onChange: e => {
        setFilter(e.target.textContent);
      },
      value: filter === 'All' ? 0 : 1
    },
    tabs: [
      {
        label: 'All',
        disabled: filter === 'All' ? true : false,
        className: classes.tab
      },
      {
        label: 'Not Read',
        disabled: filter === 'All' ? false : true,
        className: classes.tab
      }
    ],
    infiniteScrollProps: {
      hasMore: notifList.length ? false : true,
      endMessage: !notifList.length && 'You do not have any notifications',
      loader: <Loading size="small" />,
      next: () => {},
      dataLength: notifList.length,
      scrollableTarget: infoDrawerId
    }
  };
  return <InfoList {...infoListProps} />;
};

export default Notifications;
